/** The message to show when a super admin action fails. */
export const getErrorMessage = (error: unknown) => error instanceof Error ? error.message : String(error);
